import { createTheme } from "../Utils/applyTheme";

const lightTheme = createTheme({
    primary: "#6366f1",
    text: "black",
    bg: "#f3f4f6",
    bgSecondary: "white"
})
export default lightTheme